import { ChangeEvent, ReactNode } from 'react'
import { Box, Switch, Typography, useTheme } from '@mui/material'

import { useTranslation } from 'react-i18next'

import { HelperWrapper } from 'src/components/helper-wrapper'

interface IBusinessCardProps {
  handleChange: {
    (e: React.ChangeEvent<any>): void
    <T = string | ChangeEvent<any>>(
      field: T,
    ): T extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void
  }
  value: boolean
  children: ReactNode
}

export const BusinessCard = ({ value, handleChange, children }: IBusinessCardProps) => {
  const [t] = useTranslation()
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: '15px',
        padding: '16px',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Typography sx={{ fontSize: '18px', fontWeight: 600, textAlign: 'center' }}>
        <HelperWrapper t="register-additional-business-text" />
      </Typography>
      <Typography
        sx={{
          fontSize: '12px',
          textAlign: 'center',
          color: theme.palette.custom.grey2,
          pb: '8px',
        }}
      >
        <HelperWrapper t="register-additional-business-subtext" />
      </Typography>

      <Switch
        name="buisness"
        color="primary"
        id="buisness"
        size="small"
        checked={value}
        onChange={handleChange}
      />
      {children}
    </Box>
  )
}
